export default "__VITE_ASSET__shaQM57H__"